<template>
  <d-checkbox
    :class="classList"
    :icon-check="iconCheck"
    class="c-checkbox"
    v-bind="$props"
  />
</template>

<script>
import DCheckbox from 'dcode/components/DCheckbox'
import { computed } from 'vue'

export default {
  name: 'CCheckbox',
  components: {
    DCheckbox
  },
  props: {
    // Values
    value: undefined,
    name: undefined,
    text: undefined,
    helperMessage: undefined,
    validationMessage: undefined,

    // Input
    required: undefined,

    // Status
    disabled: undefined,

    // Options
    palette: undefined,
    minimum: undefined,
    right: undefined
  },
  setup (props) {
    return {
      classList: computed(() => {
        return {
          'option-minimum': props.minimum
        }
      }),

      iconCheck: computed(() => props.minimum ? '@checkbox-mini' : undefined)
    }
  }
}
</script>

<style lang="scss">
.c-checkbox {
  /* Расстояния между текст и Checkbox */
  --cb-gap: 8px;

  &.option-minimum {
    /* Размер обводка */
    --cb-size: 32px;

    /* Размер */
    --cb__ic-size: 16px;

    /* border */
    --cb__ic-border: 1px;

    /* Закругления */
    --cb__ic-radius: var(--radius-tile);

    .d-checkbox__text {
      margin-left: 0;
      margin-right: 0;
    }

    .d-checkbox__title {
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: rgba(51, 63, 72, 0.75);
    }
  }
}
</style>
